import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'
import vSelect from 'vue-select'

Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: '',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		Multiselect,
		DatePicker,
		VueElementLoading,
		vSelect
	},
	props: ['selectedRow', 'filterData'],
	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listActivitytypeData: [],
			listActivitydata: [],
			addboxemodal: false,
			id: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			boxtypesearch: '',
			warehousesearch: '',
			boxid:'',

			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			show:'',
			limitExeed:'',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			assignee:'',
			userListData:'',
			description:'',
			addactivity: {
				activitydetailsid:this.selectedRow.activitydetailsid,
				warehousesearch:this.selectedRow.warehouseid,
				clientsearch:this.selectedRow.clientid,
				activitytypesearch:this.selectedRow.activitytypeid,
				startdate:this.selectedRow.estartdate,
				enddate:this.selectedRow.eenddate,
				description:this.selectedRow.description,
				rackids:[],
				searchstatus:this.selectedRow.activitystatus
			},

			startdate:'',
			enddate:'',
			rackids:[],
			activityid:'',
			showaddcyclecount:false,
			listRackData: [],
			accordianTab: {
				1: true,
				2: false,
			},
			expanded: false,
			ActivityErr:'',
			showaddcycle:false,
			startdateErr:'',
			enddateErr:'',
     descriptionErr:'',
		 ActivityStatusErr:'',
		 pickerid :'',
		 rackidsErr:'',
		 rowData:[],
		 appendclass:true,
		 addclass:false

		}
	},

	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;
		this.NextActivity()
		this.geActivitydata()
		this.getRackData()

		this.reportname = "BoxTypeReport"
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
			this.loginUserEmail = userdetail.email;
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.getClientList();
				break;

			case 'client_user':
		  	this.loginUserEmail = userdetail.email;
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.getClientList();

				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		////////
		getWarehouseList() {
			this.pageno = 0;
			if (window.localStorage.getItem("warehouseList") !== null) {
				var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
				var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
				var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
				this.listWarehouseData = JSON.parse(plaintextwarehouse);
			} else {

				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');

				this.input = ({
					'clientid': this.clientid,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listWarehouseData = result.data.data;
					}, error => {
						console.error(error)
					})
			}
		},

		getClientList() {
			this.pageno = 0;
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {

				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');

				this.input = ({
					'warehouseid': this.warehouseid,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.listClientData = result.data.data;

					}, error => {
						console.error(error);
					});
			}
		},

		clientSelected(type) {
			if (type == 'list') {
				this.clientid = this.addactivity.clientsearch;
				if (this.clientid) {
					if (!this.warehouseid) {
						this.getWarehouseList();
						this.getActivityypeData();
					} else {
						if (this.user_type == 'warehouse_user') {
								this.addactivity.warehousesearch = this.warehouseid;
								this.getWarehouseList();
								this.getActivityypeData();
								this.getUesrsList();
								this.getRackData();
							}else{
								this.getActivityypeData();
							}
					}
				}
			} else {
				  this.clientid = this.client;
					this.getWarehouseList();
				  this.getActivityypeData();
			}
		},

		warehouseSelected(type) {
			if (type == 'list') {
				this.warehouseid = this.addactivity.warehousesearch;
				if (this.warehouseid) {
					if (!this.addactivity.clientsearch) {
						this.getClientList();
						this.getUesrsList();
					} else {
						this.getActivityypeData();
						this.getUesrsList();
						// this.getboxdata();
					}
				}
			} else {
				this.warehouseid = this.warehouse;
				this.getActivityypeData();
			}
		},
		// this function for pagination
		getActivityypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				clientid: this.clientid,
			};

			if (this.clientid) {
				 this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getActivityMaster',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listActivitytypeData = result.data.data;
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitytypeData = [];
				//	this.ClientErr = 'Client is required';
			}
		},



		getUesrsList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.addactivity.warehousesearch,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.userListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		EditActivity(){
			this.ClientErrr = '';
			this.categorynameErrr = '';
			this.rackidsErr = '';
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.addactivity.clientsearch == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.warehousesearch == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.activitytypesearch == '') {
				this.ActivityErr =  this.$t('activities.activitypeError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.startdate == '' || this.addactivity.startdate == null) {
				this.startdateErr = this.$t('common.estimatedStartDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.enddate == '' || this.addactivity.enddate == null ) {
				this.enddateErr = this.$t('common.estimatedEndDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			console.log(this.addactivity.rackids.length);
			if (this.rowData.length == 0) {
				this.rackidsErr = "Please Add Task List"
				this.pageNo = this.totalPage = 0;
				return false;
			}
			let startdate = (this.addactivity.startdate)
			let enddate = this.addactivity.enddate
			if (startdate >=  enddate) {
				this.enddateErr = this.$t('common.estimatedDateErrormsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (this.rowData.length == 0 && this.addactivity.rackids.length == 0) {
				this.rackidsErr = this.$t('common.rackidErrorMsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			var activityname =  '';
			if(this.listActivitytypeData){
			   activityname = this.listActivitytypeData.filter(obj => obj.id == this.addactivity.activitytypesearch);
		 }
			// let racks = [];
			// for (let x = 0; x < this.addactivity.rackids.length; x++) {
			// 	racks[x] = {
			// 		rackid: this.addactivity.rackids[x].trim(),
			// 	};
			// }
			let racks = [];
			for (let x = 0; x < this.rowData.length; x++) {
				let rackids = this.rowData[x].rackid.split(",");
				for(let y =0;y < rackids.length; y++){
					if(this.rowData[x].userid == null && this.rowData[x].assignedto == null){
						this.rowData[x].userid = '';
						this.rowData[x].assignedto = '';
					}
					racks.push({
					 rackid: rackids[y],
					 userid:this.rowData[x].userid,
					 assignto:this.rowData[x].assignedto,
				 });
				}
			}

			this.input = ({
				id:this.addactivity.activitydetailsid,
				clientid: this.addactivity.clientsearch,
				warehouseid: this.addactivity.warehousesearch,
				estartdate:startdate,
				eenddate:enddate,
				modifiedby: this.loginUserEmail,
				description: this.addactivity.description,
				activitystatus:'created',
				tasklist:racks
			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updateActivity',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.ErrorCode == 0) {
						this.isLoading = false
						this.$alertify.success("Updated Successfully")
						this.showList();
					} else {
						this.isLoading = false
						this.$alertify.error("Some error/Invalid data")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})

		},
		geActivitydata() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var dataFilter = {};
			this.input = ({
				clientid:this.addactivity.clientsearch,
	     	warehouseid:this.addactivity.warehousesearch,
				activitystatus:this.addactivity.searchstatus,
	    	activitytypeid:this.addactivity.activitytypesearch,
				listingtype:'tasklisting',
				id:this.addactivity.activitydetailsid,
				offset:0,
				limit:100
			});
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getActivityList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
								let arr = [], j = 0;
							 result.data.data.sort(this.compare)
							 if(result.data.data[0] != undefined)
							 {
								this.rowData.push(result.data.data[0])
								for (let i = 1; i < result.data.data.length; i++) {
								    if (this.rowData[j].userid == result.data.data[i].userid) {
											if(result.data.data[i].taskstatus != 'done' || result.data.data[i].taskstatus != 'complete' || result.data.data[i].taskstatus != 'inprocess'){
												this.rowData[j].rackid += ','
								        this.rowData[j].rackid += result.data.data[i].rackid;
											}
								    }
								    else {
											++j;
											if(result.data.data[i].taskstatus != 'done' || result.data.data[i].taskstatus != 'complete' ||result.data.data[i].taskstatus != 'inprocess'){
								        this.rowData.push(result.data.data[i])
											}
								    }
								}
							}
					})
		},
		 compare( a, b ) {
				  if ( a.userid < b.userid ){
				    return -1;
				  }
				  if ( a.userid > b.userid ){
				    return 1;
				  }
				  return 0;
			},

		getRackData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = {
				clientid: Number(this.addactivity.clientsearch),
				warehouseid:this.addactivity.warehousesearch,
				searchstring:''
			};
			if (this.addactivity.clientsearch) {
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchCycyleCountRack',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (result.data.status) {
	            for (var i = 0; i < result.data.data.length; i++) {
	              this.listRackData.push(result.data.data[i].rackno);
	            }
	          }

						for (let x = 0; x < this.rowData.length; x++) {
							let rackids = this.rowData[x].rackid.split(",");
							for(let y =0;y < rackids.length; y++){
								this.listRackData.splice(this.listRackData.indexOf(rackids[y]),1)
							}
						}
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitytypeData = [];
				//	this.ClientErr = 'Client is required';
			}
		},

		NextActivity(){
			if (this.addactivity.clientid == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.warehouseid == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.activitytypesearch == '') {
				this.ActivityErr = this.$t('activities.activitypeError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.startdate == '') {
				this.startdateErr = this.$t('common.estimatedStartDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.addactivity.enddate == '') {
				this.enddateErr =this.$t('common.estimatedEndDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if(this.addactivity.activitytypesearch == 1 ){
				this.showaddcycle = true;
				this.accordianTab[2] =true;
			}
		},
		AddRacks(){
			this.rackidsErr = '';
			if (this.addactivity.rackids.length == 0) {
				this.rackidsErr = this.$t('common.rackidErrorMsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}
		 var usermail  = ''
		 if(this.userListData){
			 if(this.pickerid){
				 let userdata = this.userListData.filter(obj => obj.userid == this.pickerid);
				 usermail = userdata[0].email
			 }
		 }
			var my_object = {
				 rackid:this.addactivity.rackids.toString(),
				 assignedto:usermail,
				 userid:this.pickerid
			 };
		 this.rowData.push(my_object)
			let racks = this.addactivity.rackids.toString();
			let rackids = racks.split(",");
			for(let i=0;i<rackids.length;i++){
				 this.listRackData.splice(this.listRackData.indexOf(rackids[i]),1)
		 }
		 this.userListData = this.userListData.filter(obj => obj.userid != this.pickerid)
		 this.rackid = '';
		 this.assignedto = '';
		 this.addactivity.rackids = '';
		 this.pickerid = '';
	 },
	 RemoveRacks(index,racks,userid,email){
		this.rowData.splice(index,1);
		let rackids = racks.split(",");
		for(let i=0;i<rackids.length;i++){
			this.listRackData.push(rackids[i])
		}
		this.userListData.push({
			userid:userid,
			email:email
		})
	},

		resetFormData() {
			this.orderid='';
			this.id = '';
			this.searchboxtype = '';
			this.boxtypesearch = '';
			this.boxid='';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			this.listActivitytypeData = [];
			this.listActivitydata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			if (this.user_type == 'warehouse_user') {
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
				this.warehouseid = '';
			} else {
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},

		onSubmit: function(e) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}

				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/activitylist/editactivity.component.js